module.exports = "//cdn-deploy.cdn.bcebos.com/muses_plt/static/img/3.3-find-password-back-link.1d7a8de1.png";